import React, {Component} from 'react';

export default class Result extends Component {
    componentDidMount() {
        // scroll to result
        if($('.result')) {
            $('html, body').animate({
                scrollTop: $('.result').offset().top - 100
            }, 'slow');
        }
    }

    render() {
        const { 
            result,
            resultDate,
            date,
            date2,
            resultDate2
        } = this.props;
        
        return (
            <div className="result">
                <h2 className="resultTitle">Resultat</h2>
                {result !== "" ?
                    <div className="resultInfo" dangerouslySetInnerHTML={{ __html: result }} /> :
                    null}
                {date2 !== undefined ?
                    <div className="resultInfo resultInfoDouble">
                        <span className="resultText">
                            {resultDate}
                        </span>
                        <span className="resultDate">
                            {date}
                        </span>
                        <span className="resultText">
                            {resultDate2}
                        </span>
                        <span className="resultDate">
                            {date2}
                        </span>
                    </div>
                    :
                    <div className="resultInfo resultInfoSingle">
                        <span className="resultDate">
                            {date}
                        </span>
                        <span className="resultText">
                            {resultDate}
                        </span>
                    </div>
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Result.js